import React, { useState, useEffect } from "react";
import classes from "./controls.module.scss";
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Button,
    Box,
    Typography
  } from '@mui/material';

  import AdminControlsDataGrid from './AdminControlsDataGrid';
  import DeleteIcon from '../../Resources/delete_icon.png'
    

import { Icon, Dialog, useToggle } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { methods } from "underscore";
import { useNavigate } from "react-router-dom";
import { constants } from "../../Shared/Url/Constants";

import SnackBar from "../../Shared/Snackbar/Snackbar";
import { CheckIsUserAdmin } from "../../Shared/Utill/Utills";
import AddRecordDialog from "./AddRecordDialog";
import { toUpperCaseString } from "../../Shared/Utill/Utills";


import {
  useGridApiRef,
  DataGridPro,
  GridToolbarContainer,
  GridActionsCellItem
} from "@mui/x-data-grid-pro";

import EditIcon from '@mui/icons-material/Edit';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CloseIcon from '@mui/icons-material/Close';

const AppControlsOnOff = () => {
    const [value, setValue] = useState("");
    const [divList, setDivList] = useState([]);
    const [divSelectedValue, setDivSelectedValue] = useState(null);
    const [appList, setAppList] = useState([]);
    const [appSelectedValue, setAppSelectedValue] = useState(null);
    const personDetails = useSelector((state) => state.personStatic.personStaticData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const token = Cookies.get('X_TKN');
    const history = useNavigate();
    const [searchApiValue, setSearchApiValue] = useState([]);
    const [searchValue, setSearchValue] = useState([]);
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const { message, severity, open } = isAlertOpen || {};
    const [deleteMessage,setDeleteMessage] = useState("");
    const [deleteMessageWarning,setDeleteMessageWarning] = useState("");
    const [deleteMessageEnd,setDeleteMessageEnd] = useState("");
    const [deleteDetails,setDeleteDetails] = useState({});
    // check user role at page
    const [openDialog, setOpenDialog] = useState(false);
    CheckIsUserAdmin();
    const dialog = useToggle();

    const [count, setCount] = React.useState(0);
    const apiRef = useGridApiRef();

    const handleRowEditStart = (params, event) => {
      event.defaultMuiPrevented = true;
    };
  
    const handleRowEditStop = (params, event) => {
      event.defaultMuiPrevented = true;
    };


    const processRowUpdate = async (newRow) => {
      console.log("processRowUpdate");
  
      console.log("new row", newRow)
      
      var result = searchApiValue.find(function(e) {
        return e.appCtlId == newRow.id;
      });
      console.log("result", result)
      let updateData = {
        ctlDescr: result.ctlDescr,
        value1: (newRow.status === "On") ? "y" : "n",
        value2: result.value2,
        isDeleteable: result.isDeleteable,
        lastUpdatedBy: personDetails.emplID
      }
      console.log("up", updateData);
      axiosInstance.put(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_UPDATE_BY_CTL_ID}/${newRow.id}`,
        updateData,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        }).then((response) => {
            // success
            setAlertOpen({
              open: true,
              severity: "success",
              message : "Application Control Updated Successfully",
            })
            handleSearch();
        })
        .catch((error) => {
            //catch
            if(error.message === 'Network Error') {
              history("/somethingwentwrong", {state:`Please logout and try again `})
            }else {
              history("/somethingwentwrong", {state:`${constants.WFM_UPDATE_BY_CTL_ID}...failed`})
              }
        });
        
      
  
      return { ...newRow, isNew: false };
    };

    const handleError = (err) => {
      console.log("handleError");
  
      console.log(err);
      setTimeout(() => {
        setCount((o) => o + 1);
      }, 1000);
    };

    const handleEditClick = (id) => (event) => {
    
      event.stopPropagation();
      apiRef.current.startRowEditMode({ id });
      
    };

    const handleSaveClick = (id) => async (event) => {
      event.stopPropagation();
      await apiRef.current.stopRowEditMode({ id });
    };
  
    const handleCancelClick = (id) => async (event) => {
      event.stopPropagation();
      await apiRef.current.stopRowEditMode({ id, ignoreModifications: true });
  
      const row = apiRef.current.getRow(id);
      if (row.isNew) {
        apiRef.current.updateRows([{ id, _action: "delete" }]);
      }
    };

    const onButtonClick = (e, id) => {
      e.stopPropagation();
      dialog.show();
      var result = searchApiValue.find(function(e) {
        return e.appCtlId == id;
      });
      let data ={
        appid: result.appid,
        locid: result.locid
      }
      setDeleteDetails(data);
      console.log(result)
      if(toUpperCaseString(result.appAbbr) === "AVL") {
        setDeleteMessage(`By deleting division ${result.divNbr}, location ${result.locNbr} you will revert the rules to the default location. (location 0).`);
        setDeleteMessageWarning("This will delete ALL controls for this location. ");
        setDeleteMessageEnd("Do you wish to continue?")
      } else if(toUpperCaseString(result.appAbbr) === "SEA") {
        setDeleteMessage(`By deleting division ${result.divNbr}, location ${result.locNbr} for "special events" you will revert the rules to the default location. (location 0).`);
        setDeleteMessageWarning("");
        setDeleteMessageEnd("Do you wish to continue?")
      }
    };
  

    const columns = [
      { field: 'division', headerName: 'Division', width: "200" },
      { field: 'location', headerName: 'Location', width: "70" },
      { field: 'application', headerName: 'Application', width: "230" },
      { field: 'status', headerName: 'Status', width: "120", editable: true, type: 'singleSelect',valueOptions: ["On", "Off"] },
      {field: "actions",
        type: "actions",
        headerName: "Action",
        width: 250,
        getActions: ({ id }) => {
          const isInEditMode = apiRef.current.getRowMode(id) === "edit";
          var result = searchApiValue.find(function(e) {
            return e.appCtlId == id;
          });
  
          if (isInEditMode) {
            return [
              <GridActionsCellItem
                icon={<SaveOutlinedIcon />}
                label="Save"
                onClick={handleSaveClick(id)}
                color="inherit"
              />,
              <GridActionsCellItem
                icon={<CloseIcon />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(id)}
                color="inherit"
              />
            ];
          }
  
          if(result && result.locNbr !== 0) {
            
              return [
                <GridActionsCellItem
                  icon={<EditIcon />}
                  label="Edit"
                  className="textPrimary"
                  onClick={handleEditClick(id)}
                  color="inherit"
                />,
                <img src={DeleteIcon} onClick={(e) => onButtonClick(e, id)} />
              ]
              
              
            
            } else {  return [
              <GridActionsCellItem
                icon={<EditIcon />}
                label="Edit"
                className="textPrimary"
                onClick={handleEditClick(id)}
                color="inherit"
              />, <div style={{width: "17px"}}></div> ]}
          
        }
      }
      
    ];

    const handleSearch = () => {

      let searchData = [];
      if(divSelectedValue === null) {
        setAlertOpen({
          open: true,
          severity: "error",
          message : "Please Select Division",
        })
      } else if(appSelectedValue === null) {
        setAlertOpen({
          open: true,
          severity: "error",
          message : "Please Select Application",
        })
      } else {

      let data = {
        divNbr: divSelectedValue !== null ? divSelectedValue.divNbr : null,
        appAbbr: appSelectedValue !== null ? appSelectedValue.appAbbr : null,
        locNbr: value === "" ? null : value,
        ctlName: "ACTIVE"
    }

     axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_DIV_APP_LOC_CTL}`, 
     data,
      {
        headers:{
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
        }
      }).then((res) => {
        
        let tmparr = []
        //console.log("response",res.data);
        res.data.map(obj => {
          let tmpobj = {}
          console.log("obj",obj)
          tmpobj.id = obj.appCtlId;
          tmpobj.division = obj.divNbr + "-" + obj.divName;
          tmpobj.location = obj.locNbr;
          tmpobj.application = obj.appName;
          tmpobj.status = toUpperCaseString(obj.value1) === 'Y' ? 'On' : 'Off';
          tmparr.push(tmpobj);
        });
        setSearchApiValue(res.data);
        setSearchValue(tmparr);
        //console.log(tmparr)
      }).catch((err) => {
        if(err.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        }else {
          history("/somethingwentwrong", {state:`${constants.WFM_GET_DIV_APP_LOC_CTL}...failed`})
          }
      });
      /*setSearchValue([
        { id: 1, division: "Macy's", location: 0, application: "Special Events Controls", status: "On" },
        { id: 2, division: "Macy's1", location: 147, application: "Special Events Controls", status: "Off"  }, 
        { id: 3, division: "Macy's2", location: 37, application: "Special Events Controls", status: "On"  }, 
      ]) */
     } // else divnbr not null
    }

    const handleAddRecord = () => {
      setOpenDialog(true);
    }
    const closeRecordDialog = () => {
      setOpenDialog(false);
    }

    const recordSavedSuccess =() => {
      setOpenDialog(false);
      setAlertOpen({
        open: true,
        severity: "success",
        message : "Record added successfully.",
      });
      //refresh grid data
      handleSearch();
    }
    const handleSave = (params, searchApiValue) => {
      // call api to update on off
       console.log("saving", params);
       console.log("api search", searchApiValue)
       var result = searchApiValue.find(function(e) {
        return e.appCtlId == params.id;
      });
      console.log("result", result)
      let updateData = {
        ctlDescr: result.ctlDescr,
        value1: (params.value === "On" || params.value === "ON") ? "y" : "n",
        value2: result.value2,
        isDeleteable: result.isDeleteable,
        lastUpdatedBy: personDetails.emplID
      }
      axiosInstance.put(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_UPDATE_BY_CTL_ID}/${params.id}`,
        updateData,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        }).then((response) => {
            // success
            setAlertOpen({
              open: true,
              severity: "success",
              message : "Application Control Updated Successfully",
            })

        })
        .catch((error) => {
            //catch
            if(error.message === 'Network Error') {
              history("/somethingwentwrong", {state:`Please logout and try again `})
            }else {
              history("/somethingwentwrong", {state:`${constants.WFM_UPDATE_BY_CTL_ID}...failed`})
              }
        });

    }    

   useEffect(() => {
    //call the API source for division list
    getDivisionListSource();
   },[]); 

   useEffect(() => {
    getApplicationDropdownByDivNbr(divSelectedValue);
   },[divSelectedValue]);

  const getDivisionListSource = () =>{
    //personDetails.mydiv; // my divNbr
    if(toUpperCaseString(personDetails.avail_admin) === "D"){
      getMyDivisionDetail();
    }
    else if(toUpperCaseString(personDetails.avail_admin) === "A"){
      getAllDivisionsList();
    }
    
  }
  
  //Network API request to get All divisions
  const getAllDivisionsList = () => {
    axios({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_ALL_DIVISIONS_URL}`,
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },
    }).then((res) => {
      
      setDivList(res.data);
    }).catch((err) => {
      if(err.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      }else {
        history("/somethingwentwrong", {state:`${constants.WFM_GET_ALL_DIVISIONS_URL}...failed`})
        }
    });

  }

  //Network API request to get my Division detail
  const getMyDivisionDetail = () => {
    let myDivNbr =personDetails.mydiv;
    axios({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_DIV_DETAIL_BY_DIVNBR}/${myDivNbr}`,
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },
    }).then((res) => {
      let divList = [];
      divList.push(res.data);
      setDivList(divList);
      setDivSelectedValue(res.data);
    }).catch((err) => {
      if(err.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      }else {
        history("/somethingwentwrong", {state:`${constants.WFM_GET_DIV_DETAIL_BY_DIVNBR}...failed`})
        }
    });

  }

  const onDivDropDownSelect = (event) => {
    let selectedDivision = event.target.value;
    setDivSelectedValue(selectedDivision);
    //set app selected null
    setAppSelectedValue(null);
  }

  //Network API request to get application dropdown
  const getApplicationDropdownByDivNbr = (selectedDivision) => {
    if(selectedDivision === null){
      return;
    }
    let divNbr = selectedDivision.divNbr;
    axios({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_APP_BY_DIV_NBR}/${divNbr}`,
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },
    }).then((res) => {
      setAppList(res.data);
    }).catch((err) => {
      if(err.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      }else {
        history("/somethingwentwrong", {state:`${constants.WFM_GET_APP_BY_DIV_NBR}...failed`})
        }
    });

  }

  const onAppDropDownSelect = (event) => {
    let selectedApp = event.target.value;
    setAppSelectedValue(selectedApp);
  }

  const handleAlertNotifClose = () => {
    setAlertOpen({});
  };

  const AddNewRecordLink = () =>{
    
    if(divSelectedValue === null){
      return null;
    }
    if(appSelectedValue === null){
      return null;
    }
    if(appSelectedValue.appAbbr.toUpperCase() != "SEA"){
      return null ;
    }
    return (
      <div className={classes.addrec} >
        <u className={classes.sethplink} onClick={() => handleAddRecord()} >Add New Records</u>
    </div>
    );
  }

  const onClickAddNewRecordLink = () => {
  }

  const deleteApp = () => {
    console.log(deleteDetails)

   

   let data = {
    appId: deleteDetails.appid,
    locId: deleteDetails.locid
   } 
   console.log(data) 
   

   axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_DELETE_BY_APP_ID_AND_LOC_ID}`, 
   data,
    {
      headers:{
      'Content-Type': 'application/json',
      'Authorization':'Bearer ' + token,
      }
    }).then((res) => {
      setAlertOpen({
        open: true,
        severity: "success",
        message : "Application deleted successfully",
      })
      
      dialog.hide();
      handleSearch();
    }).catch((err) => {
      if(err.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      }else {
        setAlertOpen({
          open: true,
          severity: "error",
          message : err.response.data.message,
        })        
        dialog.hide();
      }
    });  

    
  }
   
 
   return(<div className={classes.pagemargin}>
            <div className={classes.pagetitle} >Application Control On/Off</div>
            <div className={classes.pagesubtitle}>Search for division to manage the application or add a new record.</div>
            <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>
    <div className={classes.searchbox}>
    <FormControl sx={{ minWidth: 300, marginRight: 10  }}>
      <InputLabel id="demo-select-basic-label">Division *</InputLabel>
      <Select
        labelId="demo-select-basic-label"
        id="demo-select-basic"
        label="Dropdown Label"
        disabled={divList.length === 1}
        onChange={e => onDivDropDownSelect(e)}
        value={divSelectedValue || ''}
      >
        {divList && divList.map((e) =>
          <MenuItem key={e.divNbr} value={e}>{e.divNbr + "-" + e.divName}</MenuItem>
        )}
      </Select>
    </FormControl>

    <FormControl style={{ minWidth: 300, marginLeft: 20  }}>
      <InputLabel id="demo-select-basic-label">Application *</InputLabel>
      <Select
        labelId="demo-select-basic-label"
        id="demo-select-basic"
        label="Dropdown Label"
        onChange={e => onAppDropDownSelect(e)}
        value={appSelectedValue || ''}>
         {appList && appList.map((e) =>
          <MenuItem key={e.appId} value={e}>{e.appName}</MenuItem>
        )}
      </Select>
    </FormControl>

    <FormControl  style={{ minWidth: 300, marginLeft: 20 }}>
      <TextField 
      label="Location (Opt)"
      onChange={(e) => setValue(e.target.value)}
      value={value}
      type="number"
      // InputProps={{
      //   endAdornment: value && (
      //     <Icon 
      //     name='clear' 
      //     fontSize="30px"
      //     onClick={() => setValue("")}>
      //     </Icon>
      //   )
      // }}
       />
    </FormControl>
    <Button style={{
                marginLeft: "25px",
                paddingTop: "14px",
                paddingBottom: "14px",
                paddingLeft: "80px",
                paddingRight: "80px",
                marginRight: "5px"
              }} onClick={handleSearch}>Search</Button>
           
    
    </div>
    {appSelectedValue && divSelectedValue && <AddNewRecordLink/>}
    {openDialog && <AddRecordDialog onCloseDialog={ closeRecordDialog} onSuccessDialog={recordSavedSuccess} open={openDialog} divData={divSelectedValue} appData={appSelectedValue} />}       
    <Dialog
        open={dialog.open}
        title='Confirm Delete'
        onClose={dialog.hide}
        actions={
          <>
            <Button color="secondary" onClick={dialog.hide}>No</Button>
            <Button onClick={deleteApp}>Yes</Button>
          </>
        }
      >
        <Typography>{deleteMessage}<span style={{fontWeight: "bold", color:"red"}}>{deleteMessageWarning}</span>{deleteMessageEnd}</Typography>
      </Dialog>
      <div style={{marginTop:"30px"}}>
        <div style={{fontSize:"18px", fontWeight:"bold", marginLeft:"5px", marginBottom:"5px"}}>{searchValue.length} Results Found</div>
    <Box sx={{ height:  400, width: "90%" }} >
    {searchApiValue. length > 0  &&          
    <DataGridPro
          rows={searchValue}
          columns={columns}
          apiRef={apiRef}
          editMode="row"
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          onProcessRowUpdateError={handleError}
          
          componentsProps={{
            toolbar: { apiRef }
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />  
              
    } 
    </Box>
        </div> 
  </div>); 
}

export default AppControlsOnOff;